module.exports = "https://s91588.cdn.ngenix.net/cs-frontend-v2/_next/static/images/stopMobile-32949da71109340528e6e4b70bcb1493.png";